<button class="btn search-widget-btn" (click)="search()" title='Search'>
	<i class="fa-regular fa-magnifying-glass"></i>
</button>